import React, { useMemo } from 'react';
import classnames from 'classnames';
import { setVariationTextFields } from '../../../lib';
import { VARIATION_LISTINGS } from '../../../propTypes';
import LoadMore from '../shared/LoadMore';
import './index.scss';

const VariationListings = ({
    variations = [],
    renderChild,
    loadMore,
    wrapperClass,
    brandName,
    slogan,
    observeChanges,
    applyVerticalChanges,
}) => {
    const displayVariations = useMemo(
        () =>
            variations.map((variation) => {
                if (brandName || slogan) {
                    return setVariationTextFields({ variation, brandName, slogan });
                } else {
                    return variation;
                }
            }),
        [variations, brandName, slogan]
    );

    return (
        <div className="variation-listings">
            <div className={classnames(wrapperClass)}>
                {displayVariations.map((variation) =>
                    renderChild({
                        ...variation,
                        observeChanges,
                        applyVerticalChanges,
                    })
                )}
            </div>
            <LoadMore loadMore={loadMore} />
        </div>
    );
};

VariationListings.propTypes = VARIATION_LISTINGS;

export default VariationListings;
